import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-toggle",
  "use": "icon-toggle-usage",
  "viewBox": "0 0 30 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 30 20\" id=\"icon-toggle\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0,20v-3.33h30V20H0z M0,8.33h30v3.33H0V8.33z M0,0h30v3.33H0V0z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol